import PlatformPageTechTypes from 'store/actionTypes/platformPageTech'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {}
}

const platformPageTech = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case PlatformPageTechTypes.GET_LIST_PLATFORM_TECH_PAGE_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case PlatformPageTechTypes.GET_DETAIL_PLATFORM_TECH_PAGE_SUCCESS:
      return { ...state, current: payload }
    case PlatformPageTechTypes.UPDATE_FILTER_PLATFORM_PAGE_TECH_SUCCESS:
      return { ...state, filter: payload }
    case PlatformPageTechTypes.CLEAR_FILTER_PLATFORM_PAGE_TECH_SUCCESS:
      return { ...state, filter: initialData.filter }
    case PlatformPageTechTypes.GET_SYSTEM_PLATFORM_PAGE_TECHS_SUCCESS:
      return { ...state, systems: payload?.items }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default platformPageTech
